import React from 'react';

const MyServicesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13.205" height="12.125" viewBox="0 0 13.205 12.125">
    <path d="M402.347,426.423c-2.64-1.469-6.766-5.283-6.6-8.671a3.433,3.433,0,0,1,6.6-1.343,3.433,3.433,0,0,1,6.6,1.343C409.113,421.139,404.987,424.954,402.347,426.423Z" transform="translate(-395.744 -414.297)"/>
  </svg>
);
export default MyServicesIcon;



// WEBPACK FOOTER //
// ./src/components/Icons/MyServicesIcon.js